var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSaveFinanc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.92 189.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        fill: #d1f193;\r\n      }\r\n\r\n      .cls-4, .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.98 140.3 783.98 84.59 840.09 84.59 783.98 140.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "783.98 26.59 783.98 82.3 840.09 82.3 783.98 26.59"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.84,47c0-24.18-15.67-38.15-38.49-38.15-26.23,0-39.17,17.71-39.17,36.78,0,20.09,11.58,30.99,41.55,38.83l5.11,1.36c38.49,10.22,45.64,29.29,45.64,53.81,0,25.88-22.82,49.73-52.11,49.73s-56.2-17.71-56.2-52.45v-2.04h9.54c0,28.95,19.75,45.64,45.98,45.64,27.59,0,43.26-20.78,43.26-42.91s-9.88-35.76-43.6-44.28l-5.45-1.36c-33.04-8.17-43.25-23.16-43.25-45.64C24.65,20.1,42.36,0,73.7,0,100.95,0,121.38,16.69,121.38,47h-9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340.38,184.94v-44.96h-.68c-16.35,31.33-45.3,49.39-83.79,49.39-55.52,0-95.02-42.23-95.02-94.68S200.74,0,255.91,0C291.68,0,327.44,20.1,339.7,50.41h.68V4.43h9.54v180.51h-9.54ZM341.4,94.69c0-48.36-36.44-85.83-85.83-85.83s-85.15,35.76-85.15,85.83c0,46.66,33.72,85.83,86.51,85.83,48.36,0,84.47-38.15,84.47-85.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M458.9,184.94L384.65,4.43h9.88l70.5,169.27L534.51,4.43h10.9l-74.25,180.51h-12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M736.48,132.83c-15.33,35.42-48.02,56.54-87.53,56.54-54.49,0-95.37-40.19-95.37-94.34S594.46,0,648.95,0s94.68,43.25,94.68,92.64c0,1.7-.34,2.38-.34,3.06h-179.83c0,54.84,45.64,84.81,85.15,84.81,32.02,0,62.33-15.67,77.31-47.68h10.56ZM733.76,86.85c-2.38-45.64-43.25-78-84.13-78-45.64,0-83.1,33.04-85.83,78h169.96Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "465.03 173.71 471.16 184.95 545.41 4.43 534.51 4.43 465.03 173.71"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSaveFinanc);
export default __webpack_public_path__ + "static/media/logoSAVEFinanc.a2e50cb128dddc1e519970c18bde7b35.svg";
export { ForwardRef as ReactComponent };